module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reconciliationresult"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "top": "20%",
      "position": "relative"
    }
  }, [_c('a-icon', {
    staticStyle: {
      "font-size": "70px",
      "color": "#3ac17e",
      "margin": "0"
    },
    attrs: {
      "type": "check-circle",
      "theme": "filled"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "30px",
      "margin-top": "20px"
    }
  }, [_vm._v("结算成功")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "96px",
      "font-size": "12px"
    },
    attrs: {
      "ghost": "",
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function () {
        this$1.$router.go(-1);
      }
    }
  }, [_vm._v("返回结算列表")])], 1)])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4adc1fbc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/bdreconciliation/reconciliationresult/index.vue
// module id = 2379
// module chunks = 1